/* istanbul ignore file */
export { default } from './VehicleChooser';
